
<div *ngIf=" isLoading | async " class="overlay">
  <div class="spinner">
    <mat-progress-spinner  [color]="color" [mode]="mode" [value]="value">
    </mat-progress-spinner>
    <img class="spinner-image" src="./assets/logo-dedalus.svg">
  </div>    
</div>
